// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"547":"5d0df92c","808":"a9b6c57b"}[chunkId] + ".chunk.css";
};